import { useRef } from 'react'
import * as React from 'react'
import { useInView } from 'react-intersection-observer'
import type { CSSProperties } from 'styled-components'
import styled from 'styled-components'

import noop from 'lib/function/noop'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  top?: CSSProperties['top']
  onVisibilityChange?: (isVisible: boolean) => void
  blockNumber: number
}

const ItineraryContainer = styled.div`
  position: relative;
`

function ItineraryBlockTrigger(props: Props) {
  const {
    children,
    className,
    top = '0px',
    onVisibilityChange = noop,
    blockNumber,
    style,
    ...restProps
  } = props

  const topStr = typeof top === 'number' ? `${top}px` : top

  const { ref: contentRef } = useInView({
    rootMargin: `-${topStr} 0px 0px 0px`,
    onChange: onVisibilityChange,
  })

  const aboveChildrenRef = useRef<HTMLDivElement>(null)

  return (
    <ItineraryContainer {...restProps} className={className}>
      <div ref={aboveChildrenRef}></div>

      <div ref={contentRef}>{children}</div>
    </ItineraryContainer>
  )
}

export default ItineraryBlockTrigger
